/**
 * Manages player identity for multiplayer seat-locking and rejoining.
 */

export const PLAYER_ID_KEY = 'mp_player_id';

/**
 * Retrieves the existing playerId from localStorage or generates a new one.
 * @returns {string} The unique player ID.
 */
export const getPlayerId = (): string => {
  let playerId = localStorage.getItem(PLAYER_ID_KEY);
  
  if (!playerId) {
    // Generate a unique ID (UUID v4 style)
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
      playerId = crypto.randomUUID();
    } else {
      // Fallback for older browsers
      playerId = 'guest_' + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    }
    localStorage.setItem(PLAYER_ID_KEY, playerId);
  }
  
  return playerId;
};
